module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-4-39fb9780657ceff8d56032c6cd730e79.svg";